export default function getCroppingQueryParams(size) {
  if (!size) {
    throw new Error('Size required for image cropping');
  }
  const sizeToQueryParameters = {
    'preload': '?f_crop=1&width=10&height=6',
    '1': '?f_crop=1&width=100&height=56',
    '1_x2': '?f_crop=1&width=200&height=112',
    '2': '?f_crop=1&width=200&height=113',
    '2_x2': '?f_crop=1&width=400&height=226',
    '3': '?f_crop=1&width=300&height=169',
    '3_x2': '?f_crop=1&width=600&height=338',
    '4': '?f_crop=1&width=600&height=338',
    '4_x2': '?f_crop=1&width=1200&height=676',
    '5': '?f_crop=1&width=1000&height=563',
    '5_x2': '?f_crop=1&width=2000&height=1126',
    '6': '?f_crop=1&width=400&height=226',
  };

  return sizeToQueryParameters[size];
}



// WEBPACK FOOTER //
// ./src/util/getCroppingQueryParams.js